import Modal from "@common/Modal";
import { useLanguage } from "@src/context/LanguageContext";

interface SortingPopModalProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: (selectedOption: string) => void;
  selectedSort: string; 
setSelectedSort: (val: string) => void;
}

export default function SortingPopupModal({
  show,
  handleClose,
  onConfirm,
  selectedSort,
  setSelectedSort
}: SortingPopModalProps) {

  const {translations} = useLanguage();
  
  const options = [
    { value: "RC", label: translations?.CREATE_APP?.RECOMMENDED },
    { value: "LH", label: translations?.CREATE_APP?.LOW_TO_HIGH},
    { value: "HL", label: translations?.CREATE_APP?.HIGH_TO_LOW},
  ];
  
  return (
    <div className="sorting-modal-wrapper">
      <Modal show={show} handleClose={handleClose}>
        {/* Header */}
        <div className="sorting-modal-header">
          <h2>{translations?.COMMON_MSG?.SORT_BY}</h2>
        </div>

        {/* Body */}
        <div className="sorting-modal-body">
          <ul className="sorting-options-list">
            {options.map((opt) => (
              <li
                key={opt.value}
                className={`sorting-option ${selectedSort === opt.value ? "selected" : ""}`}
                onClick={() => setSelectedSort(opt.value)}
              >
                <span>{opt.label}</span>
                {selectedSort === opt.value && <span className="checkmark">✔</span>}
              </li>
            ))}
          </ul>
        </div>

        {/* Footer */}
        <div className="sorting-modal-footer">
          <button
            className="btn-primary full"
            onClick={() => onConfirm(selectedSort)}
          >
            {translations?.COMMON_MSG?.APPLY}
          </button>
        </div>
      </Modal>
    </div>
  );
}
